(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-chart-tab"] && !Shopify.designMode) return;
  try {
    
  $('.size_chart_tab_heading').click(function(){
    var tab_to_show = $(this).attr('data-tab');
    $('.size_chart_tab_heading').removeClass('active');
    $(this).addClass('active');
    $('.tab_content_main').hide();
    $('.tab_content_main[data-tab="'+tab_to_show+'"]').show();
});
$('.tab4').click(function(){
 $(this).parents('.size_chart').addClass('size-charst');
});
  
 $('.tab1,.tab2,.tab3').click(function(){
 $(this).parents('.size_chart').removeClass('size-charst');
}); 
  
$('span.close_custom').click(function(){
    $('.custom_popup').hide();
});
$('a.size-guide-custom').click(function(e){
e.preventDefault();
    $('.custom_popup').show();
});
$('.inch_cm_radio input[type=radio]').change(function(){
   var value_selected =  $(this).val();
    if(value_selected == 'inches'){
        $('.cm').hide();
        $('.inches').show();
    }
    else {
        $('.cm').show();
        $('.inches').hide();
    }
});
$('.measurement_heading').click(function(){
    $(this).toggleClass('active');
    $('.measurement_content').slideToggle();
});
$('.measurement_tab_item').click(function(){
    var tab_to_show = $(this).attr('data-tab');
    $('.measurement_tab_item').removeClass('active');
    $(this).addClass('active');
    $('.measurement_tab_content').hide();
    $('.measurement_tab_content[data-tab="'+tab_to_show+'"]').show();
});

  } catch(e) { console.error(e); }
})();
})();
